module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "recipe-detail"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.isLoading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "width": "100%"
    },
    style: ({
      'height': _vm.loaderHeight + 'px'
    })
  }, [_c('div', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('img', {
    staticClass: "rounded",
    attrs: {
      "width": "100px",
      "src": "static/loader-gif.gif"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n        " + _vm._s(_vm.$t('message.loadingText')) + "\n      ")])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('div', {
    staticClass: "relative bottom"
  }, [(!_vm.imageLoaded) ? _c('img', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "width": "100%",
      "src": "data:image/png;base64,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"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "imagesContainer",
    staticClass: "imgLoadContainer",
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "24px"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.recipe.photoLargeUri !== null && _vm.imageLoaded),
      expression: "recipe.photoLargeUri !== null && imageLoaded"
    }],
    attrs: {
      "src": _vm.recipe.photoLargeUri,
      "width": "100%"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.recipe.photoLargeUri == null && _vm.imageLoaded),
      expression: "recipe.photoLargeUri == null && imageLoaded"
    }],
    attrs: {
      "src": "static/recipe-placeholder.png",
      "width": "100%"
    }
  }), _vm._v(" "), (!_vm.imageLoaded) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "width": "100%"
    },
    style: ({
      'height': _vm.imageLoaderHeight
    })
  }, [_c('mu-circular-progress', {
    staticStyle: {
      "margin": "0px auto",
      "position": "absolute",
      "height": "100%",
      "width": "100%",
      "vertical-align": "middle",
      "align-items": "center",
      "display": "flex",
      "text-align": "center",
      "align-content": "center",
      "top": "0",
      "left": "calc(50% - 16px)"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "absoluteTopRight"
  }, [(_vm.recipe.userFavorites) ? _c('mu-float-button', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "icon": 'favorite',
      "background-color": "red"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onFavorite.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.recipe.userFavorites) ? _c('mu-float-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: (_vm.$t('message.addToFavouritesText')),
      expression: "$t('message.addToFavouritesText')",
      modifiers: {
        "left": true
      }
    }],
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "icon": 'favorite_border',
      "background-color": "red"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onFavorite.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-float-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.right",
      value: (_vm.$t('message.printPageText')),
      expression: "$t('message.printPageText')",
      modifiers: {
        "right": true
      }
    }],
    staticClass: "printPage",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "icon": 'print',
      "background-color": "#0179d5"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.printRecipe.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "absoluteBottomLeft"
  }, [_c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.labelPrepTime')),
      expression: "$t('message.labelPrepTime')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "greyBox"
  }, [_c('mu-icon', {
    attrs: {
      "size": 16,
      "value": "timer"
    }
  }), _vm._v("\n            " + _vm._s(_vm.recipe.preparationTime) + "min\n          ")], 1), _vm._v(" "), (_vm.recipe.cookingTime !== 0) ? _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.labelCookingTime')),
      expression: "$t('message.labelCookingTime')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "greyBox"
  }, [_c('img', {
    staticClass: "svgIcon",
    attrs: {
      "src": "static/ic_cooktime.svg"
    }
  }), _vm._v("\n            " + _vm._s(_vm.recipe.cookingTime) + "min\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Servings'),
      expression: "'Servings'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "greyBox"
  }, [_c('mu-icon', {
    attrs: {
      "size": 16,
      "value": "restaurant"
    }
  }), _vm._v("\n            " + _vm._s(_vm.recipe.servings) + "\n          ")], 1), _vm._v(" "), (_vm.recipe.userFavoriteCount !== 0) ? _c('div', {
    staticClass: "greyBox"
  }, [_c('mu-icon', {
    attrs: {
      "size": 16,
      "value": "favorite"
    }
  }), _vm._v("\n            " + _vm._s(_vm.recipe.userFavoriteCount) + "\n          ")], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "insetTitleMobile"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [_c('mu-raised-button', {
    staticClass: "fullWidthMobileBtn",
    attrs: {
      "backgroundColor": "#0179d5",
      "label": "Add to food diary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openAddToDiaryModal.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.recipe.title))]), _vm._v(" "), (_vm.recipe.author) ? _c('div', {
    staticClass: "authorBlock"
  }, [_c('p', [_vm._v("By " + _vm._s(_vm.recipe.author.firstName) + " " + _vm._s(_vm.recipe.author.lastName))])]) : _vm._e(), _vm._v(" "), _c('recipe-rating', {
    staticStyle: {
      "margin-bottom": "24px"
    },
    attrs: {
      "read-only": true,
      "count": _vm.recipe.rating.ratingCount,
      "rating": _vm.recipe.rating.ratingScore,
      "recipe": _vm.recipe
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "70",
      "tablet": "60"
    }
  }, [_c('mu-card', {
    staticClass: "bottom"
  }, [_c('mu-card-text', [(_vm.recipe) ? _c('number-spinner', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": "person"
    },
    model: {
      value: (_vm.recipe.servings),
      callback: function($$v) {
        _vm.$set(_vm.recipe, "servings", $$v)
      },
      expression: "recipe.servings"
    }
  }) : _vm._e(), _vm._v(" "), _c('h2', {
    staticStyle: {
      "margin-top": "0",
      "padding-top": "0"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.recipe.intro))]), _vm._v(" "), (_vm.recipe.suitabilities.length > 0) ? _c('div', [_c('h3', [_vm._v("Allergens")]), _vm._v(" "), _c('div', _vm._l((_vm.recipe.suitabilities), function(item, sKey) {
    return _c('mu-chip', {
      key: 's-' + sKey
    }, [_vm._v("\n                    " + _vm._s(item.label) + "\n                  ")])
  }), 1)]) : _vm._e(), _vm._v(" "), (_vm.recipe.dietaryTypes.length > 0) ? _c('div', [_c('h3', [_vm._v("Dietary types")]), _vm._v(" "), _c('div', _vm._l((_vm.recipe.dietaryTypes), function(item, dKey) {
    return _c('mu-chip', {
      key: 'd-' + dKey
    }, [_vm._v("\n                    " + _vm._s(item.label) + "\n                  ")])
  }), 1)]) : _vm._e(), _vm._v(" "), (_vm.recipe.occasions.length > 0) ? _c('div', [_c('h3', [_vm._v("Occasions")]), _vm._v(" "), _c('div', _vm._l((_vm.recipe.occasions), function(item, oKey) {
    return _c('mu-chip', {
      key: 'o-' + oKey
    }, [_vm._v("\n                    " + _vm._s(item.label) + "\n                  ")])
  }), 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1)], 1), _vm._v(" "), (_vm.recipe.video_url) ? _c('mu-card', {
    staticClass: "bottom"
  }, [_c('mu-card-header', {
    attrs: {
      "title": "Watch video",
      "titleClass": "blueTitle largeTitle"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "embedContainer"
  }, [_c('iframe-video-player', {
    attrs: {
      "autoplay": "off",
      "src": _vm.recipe.video_url,
      "width": "100%",
      "options": _vm.playerOptions
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('mu-card', {
    staticClass: "bottom"
  }, [_c('mu-card-header', {
    attrs: {
      "title": "Ingredients",
      "titleClass": "blueTitle largeTitle"
    }
  }), _vm._v(" "), _c('mu-list', _vm._l((_vm.ingredients), function(item, ingredientI) {
    return _c('mu-list-item', {
      key: 'ingredient-' + ingredientI,
      attrs: {
        "title": item.ingredientTitle
      }
    }, [_c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [(item.portionName !== 'Serving') ? _c('span', [_c('span', [_vm._v(_vm._s(item.portionQuantity) + " " + _vm._s(item.portionName) + " (" + _vm._s(item.portionValue.toFixed(1) + item.portionUnit) + ")")])]) : _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.portionQuantity.toFixed(1) + item.portionUnit + '')
      }
    }), _vm._v(" "), _c('div', [(item.allergens.length > 0) ? _c('span', [_vm._v("Allergens: ")]) : _vm._e(), _vm._v(" "), _vm._l((item.allergens), function(allergen, allergyIndex) {
      return (item.allergens.length > 0) ? _c('span', {
        key: 'allergy-index-' + allergyIndex
      }, [_vm._v(_vm._s(allergen.name)), (allergyIndex != item.allergens.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()]) : _vm._e()
    })], 2)])])
  }), 1)], 1), _vm._v(" "), _c('mu-card', {
    staticClass: "bottom",
    staticStyle: {
      "padding-bottom": "8px"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "title": "Step-by-step",
      "titleClass": "blueTitle largeTitle"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cookingInstructions",
    staticStyle: {
      "display": "none"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.recipe.cookingInstructions))
    }
  }), _vm._v(" "), _vm._l((_vm.recipe.cookingInstructions.steps), function(item, i) {
    return _c('mu-list-item', {
      key: 'instruction-' + i,
      attrs: {
        "title": _vm.parseHtmlEncoding(item)
      }
    }, [_c('mu-avatar', {
      attrs: {
        "slot": "left",
        "color": "#0179d5",
        "backgroundColor": "#E9E9E8"
      },
      slot: "left"
    }, [_vm._v("\n                " + _vm._s(i + 1) + "\n              ")])], 1)
  })], 2), _vm._v(" "), _c('recipe-reviews', {
    staticClass: "bottom hidePrint",
    attrs: {
      "recipe": _vm.recipe
    },
    on: {
      "ratingPicked": _vm.onRatingPicked
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "30",
      "tablet": "40"
    }
  }, [_c('mu-card', {
    staticClass: "bottom hidePrint"
  }, [_c('mu-card-text', [_c('food-pie', {
    staticClass: "foodPie",
    staticStyle: {
      "height": "200px",
      "width": "200px",
      "margin": "24px auto"
    },
    attrs: {
      "enable-animation": false,
      "fat": _vm.nutrition.fat.val,
      "carbs": _vm.nutrition.carbohydrate.val,
      "protein": _vm.nutrition.protein.val,
      "calories": _vm.nutrition.kcal.val
    }
  }), _vm._v(" "), _c('mu-row', {
    staticStyle: {
      "width": "100%",
      "margin-top": "16px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('span', {
    staticClass: "mediumTitle"
  }, [_c('mu-badge', {
    attrs: {
      "color": "#4ed8da !important",
      "badgeClass": "smallBadge",
      "content": "",
      "circle": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("  " + _vm._s(_vm.nutrition.carbohydrate.val.toFixed(0)) + "g")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "grey",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientCarbohydrateShort'))
    }
  })]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('span', {
    staticClass: "mediumTitle"
  }, [_c('mu-badge', {
    attrs: {
      "color": "#c04dd8 !important",
      "badgeClass": "smallBadge",
      "content": "",
      "circle": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.nutrition.fat.val.toFixed(0)) + "g")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "grey",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientFat'))
    }
  }, [_vm._v("Fat")])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('span', {
    staticClass: "mediumTitle"
  }, [_c('mu-badge', {
    attrs: {
      "color": "#e06950 !important",
      "badgeClass": "smallBadge",
      "content": "",
      "circle": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.nutrition.protein.val.toFixed(0)) + "g")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "grey",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientProtein'))
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('mu-card', {
    staticClass: "bottom"
  }, [_c('mu-card-header', {
    attrs: {
      "title": "Nutritional information",
      "subTitle": 'Per 1 serving',
      "titleClass": "blueTitle largeTitle"
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "nutritionList"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "leftItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.nutrientCarbohydrate')) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "rightItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.nutrition.carbohydrate.val.toFixed(0)) + "g\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "leftItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.nutrientSugar')) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "rightItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.nutrition.sugars.val.toFixed(0)) + "g\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "leftItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.nutrientFat')) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "rightItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.nutrition.fat.val.toFixed(0)) + "g\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "leftItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.nutrientMonounsaturatedFat')) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "rightItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.nutrition.monoFat.val.toFixed(0)) + "g\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "leftItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.nutrientPolyunsaturatedFat')) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "rightItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.nutrition.polyFat.val.toFixed(0)) + "g\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "leftItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.nutrientSaturatedFat')) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "rightItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.nutrition.satFat.val.toFixed(0)) + "g\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "leftItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.nutrientProtein')) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "rightItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.nutrition.protein.val.toFixed(0)) + "g\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "leftItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.nutrientFibre')) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "rightItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.nutrition.fibre.val.toFixed(0)) + "g\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "leftItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.nutrientPotassium')) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "rightItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.nutrition.potassium.val.toFixed(0)) + "mg\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "leftItem"
  }, [_vm._v("\n                    Salt\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "rightItem"
  }, [_vm._v("\n                    " + _vm._s(_vm.nutrition.salt.val.toFixed(0)) + "g\n                  ")])])])])], 1)], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "mobileSliderPadding",
    staticStyle: {
      "margin-left": "-24px",
      "margin-right": "-24px",
      "background": "transparent"
    }
  }, [(_vm.similarRecipes.recipes.length > 0) ? _c('h2', {
    staticStyle: {
      "padding-left": "16px",
      "padding-top": "16px",
      "margin-bottom": "2px"
    }
  }, [_vm._v("Similar\n      recipes")]) : _vm._e(), _vm._v(" "), (_vm.similarRecipes.recipes.length > 0) ? _c('mu-row', {
    staticClass: "dietaryTypes",
    attrs: {
      "gutter": ""
    }
  }, _vm._l((_vm.similarRecipes.recipes), function(item, dtIndex) {
    return _c('mu-col', {
      key: 'dt-index-' + dtIndex,
      attrs: {
        "width": "100",
        "desktop": "100",
        "tablet": "100"
      }
    }, [_c('horizontal-scroller', {
      attrs: {
        "title": item.grouping,
        "grouping-type": item.groupingType,
        "grouping-route": item.grouping,
        "recipes": item.recipes
      }
    })], 1)
  }), 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.isFoodDiaryDialogOpen,
      "title": "Add this recipe to your food diary"
    },
    on: {
      "close": _vm.onDialogClose
    }
  }, [_c('div', [_c('mu-row', [_c('mu-col', [_c('div', {
    staticClass: "mu-text-field-label"
  }, [_vm._v("\n            Date and time\n          ")]), _vm._v(" "), _c('date-picker', {
    model: {
      value: (_vm.model.date),
      callback: function($$v) {
        _vm.$set(_vm.model, "date", $$v)
      },
      expression: "model.date"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "min": 0,
      "full-width": "",
      "label": "Servings",
      "type": "number"
    },
    model: {
      value: (_vm.model.servings),
      callback: function($$v) {
        _vm.$set(_vm.model, "servings", $$v)
      },
      expression: "model.servings"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mu-text-field-label"
  }, [_vm._v("\n            Meal type\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "select",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('svg', {
    staticClass: "customMenu-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 10l5 5 5-5z"
    }
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.mealTypeId),
      expression: "model.mealTypeId"
    }],
    staticClass: "borderedSelect",
    staticStyle: {
      "margin-top": "8px",
      "width": "100%"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "mealTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.mealTypes), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 0)])], 1)], 1)], 1), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": _vm.$t('message.closeText')
    },
    on: {
      "click": function($event) {
        _vm.isFoodDiaryDialogOpen = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "slot": "actions",
      "disabled": _vm.isRecipeSaving,
      "primary": "",
      "label": _vm.$t('message.saveText')
    },
    on: {
      "click": _vm.addToFoodDiary
    },
    slot: "actions"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28d62e83","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Recipes/Detail.vue
// module id = 3647
// module chunks = 1